export default "__VITE_ASSET__BApYyo1A__"